import React from 'react';
import { Wrapper, ButtonLink } from '@crossroads/ui-components';
import { useTranslate } from '@awardit/react-use-translate';
import { useBreakpoints } from '../../helpers/use-breakpoints.js';
import cn from 'classnames';
import styles from 'shop-views/AdventCalendar.scss';

var Today = _ref => {
  var _home$data$adventCale;

  var _ref$door = _ref.door,
      day = _ref$door.day,
      category = _ref$door.category,
      home = _ref.home,
      ProductListComponent = _ref.ProductListComponent,
      hasAlternativeLayout = _ref.hasAlternativeLayout,
      buttonVariant = _ref.buttonVariant;
  var t = useTranslate();

  var _useBreakpoints = useBreakpoints(styles),
      getNumberOfDisplayedItems = _useBreakpoints.getNumberOfDisplayedItems;

  var productsToShow = getNumberOfDisplayedItems({
    tiny: 1,
    small: 2,
    medium: 3
  }, 4);
  var url = category.url,
      name = category.name,
      description = category.description,
      bannerSmall = category.bannerSmall,
      bannerMedium = category.bannerMedium,
      bannerLarge = category.bannerLarge,
      products = category.products;
  var parentCategoryBanner = home.state === "LOADED" && ((_home$data$adventCale = home.data.adventCalendar) == null ? void 0 : _home$data$adventCale.category.clsCatfieldsGeneralImgL) !== undefined && home.data.adventCalendar.category.clsCatfieldsGeneralImgL !== null ? home.data.adventCalendar.category.clsCatfieldsGeneralImgL : null;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.today
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement("div", {
    className: cn({
      [styles.todayInner]: hasAlternativeLayout
    })
  }, (bannerSmall && bannerMedium && bannerLarge || parentCategoryBanner) && /*#__PURE__*/React.createElement("div", {
    className: styles.todayBanner
  }, bannerSmall && bannerMedium && bannerLarge ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.todaySmallBanner,
    style: {
      backgroundImage: `url(${bannerSmall.x2 || ""})`
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.todayMediumBanner,
    style: {
      backgroundImage: `url(${bannerMedium.x2 || ""})`
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.todayLargeBanner,
    style: {
      backgroundImage: `url(${bannerLarge.x2 || ""})`
    }
  })) : /*#__PURE__*/React.createElement("div", {
    className: cn(styles.todayLargeBanner, styles.todayMediumBanner, styles.todaySmallBanner),
    style: {
      backgroundImage: `url(${(parentCategoryBanner == null ? void 0 : parentCategoryBanner.x2) || ""})`
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.todayContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.todayContent
  }, /*#__PURE__*/React.createElement("h2", null, t("ADVENT_CALENDAR.DOOR_TITLE", {
    day
  })), /*#__PURE__*/React.createElement("h3", null, name), hasAlternativeLayout && /*#__PURE__*/React.createElement("div", {
    className: styles.descriptionContainer
  }, /*#__PURE__*/React.createElement("p", null, description), /*#__PURE__*/React.createElement(ButtonLink, {
    variant: buttonVariant,
    to: url,
    className: styles.todayViewAll
  }, t("ADVENT_CALENDAR.VIEW_ALL_PRODUCTS"))))), !hasAlternativeLayout ? /*#__PURE__*/React.createElement(React.Fragment, null, ProductListComponent ? /*#__PURE__*/React.createElement("div", {
    className: styles.todayProductList
  }, /*#__PURE__*/React.createElement(ProductListComponent, {
    products: products.items.slice(0, productsToShow)
  })) : null, products.totalCount > 4 && /*#__PURE__*/React.createElement("div", {
    className: styles.descriptionContainer
  }, /*#__PURE__*/React.createElement(ButtonLink, {
    variant: buttonVariant,
    to: url,
    className: styles.todayViewAll
  }, t("ADVENT_CALENDAR.VIEW_ALL_PRODUCTS")))) : null)));
};

export { Today };
//# sourceMappingURL=index.js.map
